<template>
  <div class="welcome">
    <h1 class="maintitle title is-size-3-mobile is-size-2-tablet">
      KRENKINGSCOACHING
    </h1>
    <p class="content">{{ welcomeText }}</p>
    <button
      class="button is-success is-large is-size-5-mobile is-size-4-tablet is-size-3-desktop"
      @click="gowaitingroom"
    >
      naar de wachtkamer
    </button>
  </div>
</template>

<script>
//import { useRouter } from 'vue-router';
import { computed } from 'vue';
import { useStore } from 'vuex';
export default {
  name: 'Home',
  components: {},
  setup() {
    // const router = useRouter();
    const store = useStore();
    const welcomeText = computed(() => {
      return store.state.welcomeText;
    });
    const gowaitingroom = async () => {
      store.commit('clearUser');
      store.commit('joinRoom', 'waitingroom');
    };
    return {
      gowaitingroom,
      welcomeText,
    };
  },
};
</script>
<style lang="scss" scoped>
.loginlink {
  color: black;
  position: absolute;
  padding: $margin;
  right: 0;
  top: 0;
}
.loginlink:hover {
  color: white;
}
.welcome {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  text-shadow: 2px 2px 1px $black;
  height: 100vh;
  font-weight: bold;
  max-width: 30 * $defaultSize;
  margin: auto 0;
}
</style>
